/** @format */

'use strict';

//The factory to crud the main object
angular.module('emsApp').factory('DocumentTypeFactory', function($resource) {
	return $resource(
		'api/documentTypes/:id',
		{},
		{
			query: { method: 'GET', isArray: false },
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
			update: { method: 'PUT' },
		}
	);
});

//The factory to fetch a new object with defaults from server
angular.module('emsApp').factory('NewDocumentTypeFactory', function($resource) {
	return $resource(
		'api/documentTypes/new',
		{},
		{
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
		}
	);
});

//Get all DocumentTypes without the use of paging
angular.module('emsApp').factory('NoPagingDocumentTypeFactory', function($resource) {
	return $resource(
		'api/documentTypes/nopaging',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

angular.module('emsApp').factory('FindAllDocumentTypesByQueryParamsFactory', function($resource) {
	return $resource(
		'api/query/documentTypes/',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});
